module.exports = __webpack_public_path__ + "img/339.2e25a4b.png";